// extracted by mini-css-extract-plugin
module.exports = {"orgItem":"OrgSwitcher_orgItem__Ib_FN","icon":"OrgSwitcher_icon__8aohK"};